import { Crew } from '@src/main/modules/ibdp/domain/crew.interface';
import { FleetTime } from '@src/main/modules/ibdp/domain/fleet-time.interface';
import { IbdpRepository } from '@src/main/modules/ibdp/domain/ibdp.repository';
import { CrewEntity } from '@src/main/modules/ibdp/infrastructure/crew.entity';
import { toCrew } from '@src/main/modules/ibdp/infrastructure/crew.mapper';
import { FleetTimeEntity } from '@src/main/modules/ibdp/infrastructure/fleet-time.entity';
import { toFleetTime } from '@src/main/modules/ibdp/infrastructure/fleet-time.mapper';
import { api, TokenProvider } from '@src/main/shared/infrastructure/entity/axios';

export const createIbdpHttpRepository = (tokenProvider: TokenProvider): IbdpRepository =>
  new IbdpHttpRepository(tokenProvider);

class IbdpHttpRepository implements IbdpRepository {
  private readonly tokenProvider: TokenProvider;

  constructor(tokenProvider: TokenProvider) {
    this.tokenProvider = tokenProvider;
  }

  private static readonly BASE_URL = '/ibdp';

  private async getAuthToken(): Promise<string> {
    const token = await this.tokenProvider.getToken();
    if (!token) {
      throw new Error('Authentication token is missing');
    }
    return token;
  }

  async findCrewSearch(filter: string): Promise<Crew[]> {
    const token = await this.getAuthToken();

    const response = await api.get<CrewEntity[]>(
      `${IbdpHttpRepository.BASE_URL}/crew_search`,
      token,
      {
        filter,
      },
    );
    return response.map(toCrew);
  }

  async findFleets(fleet: string, subFleet: string): Promise<FleetTime[]> {
    const token = await this.getAuthToken();

    const response = await api.get<FleetTimeEntity[]>(
      `${IbdpHttpRepository.BASE_URL}/fleetTime`,
      token,
      {
        fleet,
        subFleet,
      },
    );
    return response.map(toFleetTime);
  }
}
